module.exports = __webpack_public_path__ + "static/media/Helicopter.7b2604b1.mp3";